import { render, staticRenderFns } from "./BulkRegistrationSelfService.vue?vue&type=template&id=6caa8543&scoped=true&"
import script from "./BulkRegistrationSelfService.vue?vue&type=script&lang=js&"
export * from "./BulkRegistrationSelfService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caa8543",
  null
  
)

export default component.exports